import React, { useState } from "react";

import {
  AccountIcon,
  DocsIcon,
  HelpIcon,
  LogoutIcon,
  ProfileIcon,
  ProfileMenu,
} from "@atsent/components";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetProfile } from "lib/store/user";
import { modalState } from "lib/store/common";

import "./Profile.scss";

export type ProfileProps = {
  cx?: string;
};

export const Profile: React.FC<ProfileProps> = ({ cx = "" }) => {
  const user = useRecoilValueLoadable(asyncGetProfile);
  const setModalState = useSetRecoilState(modalState);
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div
      className={`Profile ${cx}`}
      onClick={() => setShowMenu((state) => !state)}
    >
      <ProfileIcon username={user.contents.username ?? ""} />
      {showMenu && (
        <ProfileMenu
          username={user.contents.username ?? ""}
          email={user.contents.email ?? ""}
          list={[
            {
              text: "My Account",
              icon: <AccountIcon />,
              click: () => setModalState((_) => ({ ..._, myAccount: true })),
            },
            {
              icon: <DocsIcon />,
              click: () => window.open("https://docs.atsent.ai/"),
              text: "Docs",
            },
            {
              icon: <HelpIcon />,
              click: () => window.open("https://www.onmydev.com"),
              text: "Help desk",
            },
            {
              icon: <LogoutIcon />,
              click: () => {
                window.location.href = "/";
                localStorage.clear();
              },
              text: "Logout",
            },
          ]}
        />
      )}
    </div>
  );
};
